import Carousel from 'react-multi-carousel'
import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const CarouselContainer = styled(Carousel)`
  ${({ theme }) => `
    padding-bottom: ${theme.space.mobile.large};
  `}

  ${({ theme }) => media.sm`
    padding-bottom: ${theme.space.desktop.large};
  `}

  .slideshow-dots-list {
    z-index: 2;
    display: flex;
    align-items: center;
    height: 30px;

    ${({ theme }) => media.sm`
      left: ${theme.space.mobile.large};
      right: ${theme.space.mobile.large};
    `}
  }
`
